/* eslint-disable */

import Filters from '../modules/filters';
import stickySidebar from '../modules/stickySidebar';
import Placeholder from '../modules/placeholder';
import Pagination from '../modules/pagination';
import { ParamsData } from '../app';


function stickSearch(element, element_sticky) {

    const header = document.getElementById("header");
    const wrapper = document.querySelector(".block-search-wrapper");
    let height = element.offsetHeight;
    let top = wrapper.offsetTop + wrapper.offsetHeight;
    let old = false;
    let sticky = false;

    const onresize = () => {
        height = element.offsetHeight;
        top = wrapper.offsetTop;
    }

    let gg;
    let gg1;

    const onscroll = () => {
        sticky = window.scrollY > top - 150 ? true : false;

        if (old != sticky) {
            if (sticky) {
                element.classList.remove('opened');
                header.classList.add("hasSticky");
                element_sticky.classList.add("show");
                element.classList.add('sticky');
                element.style.height = `${element.querySelector("form").offsetHeight}px`;

                clearTimeout(gg);

                gg1 = setTimeout(() => {
                    element.classList.add('opened');

                }, 700)
            } else {
                clearTimeout(gg1);
                element.style.height = `0`;
                element.classList.remove('opened');
                gg = setTimeout(() => {
                    header.classList.remove("hasSticky");
                    element.style = ``;
                    element_sticky.classList.remove("show");
                    element.classList.remove('sticky');

                }, 900)
            }
        }

        old = sticky;
    }

    window.addEventListener('scroll', onscroll);
    window.addEventListener('resize', onresize);

    // tricks because back button on ios dontreload page
    window.onpageshow = function (event) {
        if (event.persisted) {
            top = wrapper.offsetTop + wrapper.offsetHeight;
            old = false;
            sticky = false;
            onscroll();
        }
    };

    // display without fx 
    if (window.scrollY > top - 150 ? true : false) {
        element.classList.add("nofx");
        element_sticky.classList.add("show");
        element.classList.add('sticky');
        element.style.height = `${element.querySelector("form").offsetHeight}px`;
        element.classList.add('opened');
        setTimeout(() => element.classList.remove("nofx"), 1)
    } else {
        onscroll();
    }

}

export default el => {

    // datepicker
    let picker;
    let btn_picker;
    var today = new Date();
    const script = document.createElement("script");
    script.src = '/wp-content/themes/gide/assets/plugins/easepick.umd.js';
    document.querySelector("head").appendChild(script);
    script.onload = () => {
        picker = new easepick.create({
            element: "#datepicker",
            css: [
                `${ParamsData.wp_theme_url}assets/plugins/easepick.css`,
                `${ParamsData.wp_theme_url}assets/css/easypick.css`,

            ],
            grid: 2,
            zIndex: 10,
            calendars: 2,
            inline: false,
            AmpPlugin: {
                dropdown: {
                    months: true,
                    years: true,
                    minYear: 2020
                },
                darkMode: false
            },
            LockPlugin: {
                maxDate: today,
                minDays: 0
            },
            plugins: [
                "AmpPlugin",
                "RangePlugin",
                "LockPlugin",

            ],
            lang: document.querySelector("html").getAttribute("lang")
        })
        picker.on('select', (e) => {
            picker.hide();
            btn_picker.classList.remove("open");
            submit();
        });
        picker.grid = 1;
    }

    stickySidebar();

    const block_search = el.querySelector('.block-search');
    const form = block_search.querySelector(".block-search form");
    const input = form.querySelector(".search input");
    const block_search_sticky = el.querySelector('.block-search-sticky');
    const input_sticky = block_search_sticky.querySelector(".search input");
    const category = el.querySelector('.category');
    const result = el.querySelector('.header-result');
    let page = 1;

    const placeholder = new Placeholder();
    const pagination = new Pagination(el, page);

    const place = (btn) => {
        if (datepicker) {
            datepicker.style.width = `${btn.offsetWidth}px`;
            const easepick_wrapper = document.querySelector(".easepick-wrapper");
            easepick_wrapper.style.left = `${datepicker.offsetLeft}px`;
        }
    }

    const filters = new Filters((btn) => {
        btn_picker = btn;
        if (btn.classList.contains("open")) {
            place(btn);
            picker.show();

        } else {
            picker.hide();
        }
    });

    pagination.click = newpage => {
        page = newpage;
        submit(true);
    };

    filters.reset = () => {
        picker.clear()
        submit()
    };

    filters.click = (isDatePicker) => {
        isDatePicker && picker.clear()
        submit();
    }

    // set checked filters if in url
    const params = new URLSearchParams(window.location.search);
    const sExpertise = params.get("expertises") ? params.get("expertises").split(",") : [];
    const sOffices = params.get("offices") ? params.get("offices").split(",") : [];
    const sCategories = params.get("categories") ? params.get("categories").split(",") : [];
    [...sExpertise, ...sOffices, ...sCategories].forEach(input => {
        document.querySelector(`input[value="${input}"]`).checked = true;
    })

    stickSearch(block_search, block_search_sticky);

    const changeUrl = (expertises, offices, categories) => {
        const urlexpertises = expertises.length ? `expertises=${expertises}` : "";
        const urloffices = offices.length ? `offices=${offices}` : "";
        const urlcategories = categories.length ? `categories=${categories}` : "";
        const uri = `${urlexpertises}${expertises.length && urloffices.length ? "&" : ""}${urloffices}${urlcategories && (expertises.length || urloffices.length) ? "&" : ""}${urlcategories}`;
        window.history.pushState({}, "", `?${uri}`);
    }

    const location = window.location;

    function submit(isPagination) {
        const url = ParamsData.wp_ajax_url;
        const formData = new FormData();
        formData.append('nonce', form.dataset.nonce);
        formData.append('action', form.getAttribute('action'));

        const expertises = [];
        form.querySelectorAll('input[name="expertises"]:checked').forEach(checkbox => expertises.push(checkbox.value));
        formData.set('expertises', expertises);

        const offices = [];
        form.querySelectorAll('input[name="offices"]:checked').forEach(checkbox => offices.push(checkbox.value));
        formData.set('offices', offices);
        formData.set('page', isPagination ? page : 1);
        formData.append('lang', ParamsData.wp_lang);
        formData.append('keyword', input.value);

        const categories = [];
        category.querySelectorAll('input:checked').forEach(checkbox => categories.push(checkbox.value));
        formData.set('categories', categories);

        const datepicker = document.getElementById("datepicker");
        const dates = datepicker.value.split(" - ");
        formData.append('date-begin', dates[0] || "");
        formData.append('date-end', dates[1] || "");
        document.body.classList.add('loading');

        // set new url with filters
        changeUrl(expertises, offices, categories);

        document.querySelector('.hero').scrollIntoView({ behavior: "smooth" });
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.onload = () => {
            const response = JSON.parse(xhr.response);

            document.querySelector(".xhr-result .list-cards").innerHTML = response.html;

            const total = response.pagination.total;

            filters.display(total);


            page = Number(response.pagination.page);

            pagination.set(response.pagination.last_page, page);

            if (total === 0) result.classList.add("show","error");
            else {
                result.classList.add("show");
            }

            if (page === 1) {
                document.querySelector(".xhr-result .list-cards").classList.add('first-page')
            } else {
                document.querySelector(".xhr-result .list-cards").classList.remove('first-page')
            }

            document.body.classList.remove('loading');
        }

        xhr.send(formData);
    }

    form.onsubmit = e => {
        e.preventDefault();
        submit();
    }

    // gestion doublon avec sticky bar
    input.addEventListener("input", () => {
        input_sticky.value = input.value;
        if (input.value.length > 0) placeholder.hide();
        else placeholder.show();
    })

    input_sticky.addEventListener("input", () => {
        input.value = input_sticky.value;
        if (input_sticky.value.length > 0) placeholder.hide();
        else placeholder.show();
    })

    filters.display(el.dataset.total);
};
